/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12Inputs */

const en__field_ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12 = /** @type {(inputs: _Field_Ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I agree that photos and videos will be taken at the event`)
};

const de__field_ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12 = /** @type {(inputs: _Field_Ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich bin einverstanden, dass am Veranstaltungstag Fotos und Videos von mir gemacht werden`)
};

/**
* | output |
* | --- |
* | "I agree that photos and videos will be taken at the event" |
*
* @param {_Field_Ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12 = /** @type {((inputs?: _Field_Ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12(inputs)
	return de__field_ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12(inputs)
});
export { _field_ichbineinverstandendassamveranstaltungstagfotosundvideosvonmirgemachtwerden12 as "_field_ichBinEinverstandenDassAmVeranstaltungstagFotosUndVideosVonMirGemachtWerden" }